import * as React from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { connect } from "react-redux";
import { Table, Tag } from "antd";
import moment from "moment";
import ImageComponent from "./ImageComponent";
import { receiveInbound } from "../store/actions/imsAdminActions";
import {
  antTableWrapperSx,
  defaultPaginatedTableProps,
  idTableColumn,
} from "./AntTableStyles";

export const InboundsTable = ({
  products,
  receiveInbound,
  page,
  setPage,
  pagination,
  rowSelection,
  isLoading,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [quantities, setQuantities] = React.useState({});

  React.useEffect(() => {
    if (products && !products.docs) {
      const intermediate = {};
      products?.map((product) => (intermediate[product._id] = 0));
      setQuantities(intermediate);
    }
  }, [products]);

  const columns = [
    idTableColumn({ title: "Inbound ID", dataIndex: "inboundId" }),
    {
      title: "Product SKU",
      dataIndex: "sku",
    },
    {
      title: "Date Created",
      dataIndex: "date",
      sorter: (a, b) => {
        return moment(a.date).isBefore(b.date) ? -1 : 1;
      },
    },
    {
      title: "Image",
      dataIndex: "image",
      render: (text) => (
        <ImageComponent width={50} height={50} src={text} preview={true} />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Size",
      dataIndex: "size",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (_, { status }) => (
        <Tag
          color={
            status === "Received"
              ? "green"
              : status === "Cancelled"
                ? "red"
                : status === "Pending"
                  ? "yellow"
                  : "blue"
          }
        >
          {status.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: "Vendor",
      dataIndex: "vendor",
    },
    {
      title: "QTY Sent",
      dataIndex: "quantity",
    },
    {
      title: "QTY Received",
      dataIndex: "quantityReceived",
    },
  ];

  const data = products
    ?.filter((row) => row.inbound.vendor !== null)
    .map((row) => {
      return {
        _id: row._id,
        key: row._id,
        inboundId: row.inbound._id,
        date: moment(row.createdAt).format("lll"),
        sku: row.product.sku,
        image: row.product.image,
        name: row.product.name,
        size: row.product.size,
        color: row.product.color,
        weight: row.product.weight,
        status: row.inbound.status,
        quantity: row.quantity,
        quantityReceived: row.quantityReceived,
        vendor: row.inbound.vendor.name,
      };
    });

  return (
    <Box sx={antTableWrapperSx(isMobile)}>
      {quantities && (
        <Table
          columns={columns}
          rowSelection={rowSelection}
          dataSource={data}
          loading={isLoading}
          showSorterTooltip={{
            target: "sorter-icon",
          }}
          pagination={defaultPaginatedTableProps({
            current: page,
            pageSize: parseInt(pagination?.limit) || 100,
            total: pagination?.totalDocs,
            onChange: (nextPage) => setPage(nextPage),
          })}
          scroll={{ x: isMobile ? 300 : 1200 }}
        />
      )}
    </Box>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state?.records?.isLoading,
});

const mapDispatchToProps = { receiveInbound };

export default connect(mapStateToProps, mapDispatchToProps)(InboundsTable);
